import { render, staticRenderFns } from "./Franchisees.vue?vue&type=template&id=98095a66&scoped=true&"
import script from "./Franchisees.vue?vue&type=script&lang=js&"
export * from "./Franchisees.vue?vue&type=script&lang=js&"
import style0 from "./Franchisees.vue?vue&type=style&index=0&id=98095a66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98095a66",
  null
  
)

export default component.exports